export const TIMEZONES = [
  {
    timezone: 'Eastern Standard Time',
    code: 'EST',
    offset: 'GMT -05:00',
  },
  {
    timezone: 'Central Standard Time',
    code: 'CST',
    offset: 'GMT -06:00',
  },
  {
    timezone: 'Mountain Standard Time',
    code: 'MST',
    offset: 'GMT -07:00',
  },
  {
    timezone: 'Pacific Standard Time',
    code: 'PST',
    offset: 'GMT -08:00',
  },
  {
    timezone: 'Alaska Standard Time',
    code: 'AKST',
    offset: 'GMT -09:00',
  },
  {
    timezone: 'Hawaii-Aleutian Standard Time',
    code: 'HAST',
    offset: 'GMT -10:00',
  },
];
